import React, { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./markregularization.css";
import DropDownInput from "../Input/dropDownInput/dropDownInput";
import FileUpload from "../FileUploads/FileUpload";
import { toast } from "react-toastify";
import SuccessModal from "../CustomModal/Success";
import FailedModal from "../CustomModal/Failed";

const MarkRegularization = ({
  match,
  history,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  saveRegularization,
  insertRegularization,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [inputList, setInputList] = useState({
    reason_for_missed_attendance: "",
    location_of_work: "",
    regularization_date: "",
    check_in_time: "",
    check_out_time: "",
    message: "",
    attachment: "",
    regularization_mode: "",
  });

  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().split("T")[0];
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };

  const handleInputChange = (val, field) => {
    setInputList((prevList) => ({
      ...prevList,
      [field]: val,
    }));
  };

  const particularDate = match.params.date;

  useEffect(() => {
    const currentTime = getCurrentTime();
    setInputList((prevList) => ({
      ...prevList,
      regularization_date: particularDate,
      regularization_mode: 0,
      check_in_time: currentTime,
      check_out_time: currentTime,
    }));
  }, [particularDate]);

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    // show check out after complete activity
    if (
      insertRegularization?.data !== undefined &&
      insertRegularization?.status === 200
    ) {
      setMessage(insertRegularization?.message);
      setIsSuccessModalOpen(true);
    } else if (
      insertRegularization?.data !== undefined &&
      insertRegularization?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      console.log("TEST: ", insertRegularization);
      setMessage(insertRegularization?.message);
    }
  }, [insertRegularization]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputList.reason_for_missed_attendance === "") {
      toast.error("Please select the reason");
    }
    if (inputList.location_of_work === "") {
      toast.error("Please select the location");
    }
    if (inputList.check_in_time === "") {
      toast.error("Please select the the check-in time");
    }
    if (inputList.check_out_time === "") {
      toast.error("Please select the the check-out time");
    }
    if (inputList.message === "") {
      toast.error("Please enter the reason");
    }
    if (inputList.check_in_time === getCurrentTime()) {
      toast.error("Please select the check-in time");
    }
    if (inputList.check_out_time === getCurrentTime()) {
      toast.error("Please select the check-out time");
    }

    // console.log("Input Fields:", inputList);
    // return false;
    setIsLoading(true);
    const res = await saveRegularization(inputList);
    // console.log("RES: ", res);
    // if (res) {
    //   toast.success("Regularization request submitted successfully!");
    //   window.location.href = "/monthly-regularization";
    // } else {
    //   toast.error("Failed to submit regularization request.");
    // }
    setIsLoading(false);
  };

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={message}
        url={`/monthly-regularization`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Regularization Request"} history={history} />
            <div className="container-fluid common-bg">
              {/* Heading */}

              <div className="container-fluid bootstrap snippets bg-white">
                <div className="container">
                  {/* <div className="text-center">
                    <h1>Regularization Request</h1>
                  </div> */}
                  <div className="regular-form-group">
                    <label className="large-label">
                      Reason for missed attendance{" "}
                      <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <DropDownInput
                      data={[
                        {
                          id: "Technical Issue",
                          name: "Technical Issue",
                        },
                        {
                          id: "Missed Marking Attendance",
                          name: "Missed Marking Attendance",
                        },
                      ]}
                      label={""}
                      getIdValue={(val) => {
                        handleInputChange(
                          val.id,
                          "reason_for_missed_attendance"
                        );
                      }}
                    />
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      Location of work{" "}
                      <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <DropDownInput
                      data={[
                        {
                          id: "On Site",
                          name: "On Site",
                        },
                        {
                          id: "Work From Office",
                          name: "Work From Office",
                        },
                        {
                          id: "Work Out Of Office",
                          name: "Work Out Of Office",
                        },
                      ]}
                      label={""}
                      getIdValue={(val) => {
                        handleInputChange(val.id, "location_of_work");
                      }}
                    />
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      Date{" "}
                      <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <input
                      className="date-calendar"
                      type="text"
                      value={inputList.regularization_date}
                      defaultValue={particularDate}
                      disabled
                    />
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      From{" "}
                      <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <input
                      className="date-time"
                      type="time"
                      // id="timeFrom"
                      value={inputList.check_in_time}
                      onChange={(e) =>
                        handleInputChange(e.target.value, "check_in_time")
                      }
                      defaultValue={getCurrentTime()}
                    />
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      To <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <input
                      className="date-time"
                      type="time"
                      // id="timeTo"
                      value={inputList.check_out_time}
                      onChange={(e) =>
                        handleInputChange(e.target.value, "check_out_time")
                      }
                      defaultValue={getCurrentTime()}
                    />
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      Reason{" "}
                      <i className="bi bi-asterisk payout-astrick-icon"></i>
                    </label>
                    <textarea
                      id="message"
                      placeholder="Type your message"
                      onChange={(e) => {
                        handleInputChange(e.target.value, "message");
                      }}
                    ></textarea>
                  </div>
                  <div className="regular-form-group">
                    <label className="large-label">
                      Upload attachments{" "}
                      {/* <i className="bi bi-asterisk payout-astrick-icon"></i> */}
                    </label>
                    <FileUpload
                      id={"addAttachment"}
                      accept=".png,.jpg,.jpeg"
                      documentUploadUrl={documentUploadUrlPublic}
                      documentUrlData={documentUrlDataPublic}
                      onChange={(val) => {
                        handleInputChange(val, "attachment");
                      }}
                      prefilledFilename={""}
                      multiple={true}
                    ></FileUpload>
                  </div>
                  <button
                    className="btn btn-primary mt-3"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section ends */}
    </>
  );
};

export default MarkRegularization;
